/**
=========================================================
* Material Dashboard 3 PRO React - v2.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function QConCard({ value }) {
  return (
    <Card
      sx={{
        backgroundColor: "#ffffff",
        borderRadius: "4px",
        overflow: "hidden",
        flex: 1,
        minWidth: "200px",
      }}
    >
      <MDBox
        sx={{
          padding: "1.5rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100px",
        }}
      >
        <MDTypography
          variant="caption"
          color="black"
          sx={{
            fontSize: "0.75rem",
            display: "block",
            mb: 1,
            fontWeight: "medium",
            textTransform: "uppercase",
          }}
        >
          qCON
        </MDTypography>
        <MDTypography
          variant="h2"
          fontWeight="bold"
          color="black"
          sx={{
            fontSize: "3.5rem",
            lineHeight: 1.2,
          }}
        >
          {value}
        </MDTypography>
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of QConCard
QConCard.defaultProps = {
  value: "94",
};

// Typechecking props for the QConCard
QConCard.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default QConCard;

